import { tv } from 'tailwind-variants';

export const styles = {
  header: tv({
    base: 'z-[1] border-b border-[transparent]',
    variants: {
      scrolled: {
        true: 'border-neutral20',
      },
    },
  }),
};
